module.exports = "https://cdn.realtymogul.com/static/media/Brian_S.12827ab7.jpg";